module.exports = __webpack_public_path__ + "static/media/tips.91516cdc.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./public/images/doodles/tips.svg
 ** module id = 2081
 ** module chunks = 44
 **/